module.exports = __webpack_public_path__ + "static/media/Heart_ON@3x.ac7e0add.png";